import get from 'lodash/get';
import mergeWith from 'lodash/mergeWith';
import { arrayOverwriteStrategy } from '@/utils/objects';
// Combines primary and secondary grid settings,
// ensuring secondary inherits all primary properties.
export const getGridSettings = theme => {
  const gridSettings = get(theme, 'elements.chart.grid', {});
  const gridSecondarySettings = get(theme, 'elements.chart.gridSecondary', {});
  return {
    grid: gridSettings,
    gridSecondary: mergeWith({}, gridSettings, gridSecondarySettings, arrayOverwriteStrategy)
  };
}; // Cleans and validates a single color palette

export const cleanPalette = (palette, index) => {
  // Skip processing if palette is falsy
  if (!palette) return null; // Filter out falsy color values

  const validColors = (palette.colors || []).filter(Boolean); // Skip palette if no valid colors remain

  if (validColors.length === 0) return null;
  return {
    name: palette.name || `Palette ${index + 1}`,
    // Fallback to default name
    colors: validColors
  };
}; // Cleans and filters an array of color palettes

export const cleanPalettes = palettes => {
  if (!palettes || !Array.isArray(palettes)) return []; // Clean each palette and filter out null results

  return palettes.map(cleanPalette).filter(palette => Boolean(palette)); // Remove null/undefined entries
};